export const GLOBAL_STATE = 'Roles'

export const ROLE = 'role'
export const ROLE_CREATE = 'create'
export const ROLE_LIST = 'roleList'
export const ROLE_ALL = 'roleAll'
